import { matchPath } from "react-router-dom";
import { RolUsuario, RespuestaUsuario } from "./authServicios";
import {
  RUTA_INICIO,
  RUTA_NO_AUTORIZADA,
  RUTA_PROPIETARIOS,
  RUTA_PROPIETARIOS_CREAR,
  RUTA_PROPIETARIOS_EDITAR,
  RUTA_PROPIETARIOS_ID,
  RUTA_PROPIETARIOS_MASCOTAS_CREAR,
  RUTA_PROPIETARIOS_MASCOTAS,
  RUTA_MASCOTAS,
  RUTA_MASCOTAS_EDITAR,
  RUTA_MASCOTAS_ID,
  RUTA_SERVICIOS,
  RUTA_SERVICIOS_PRODUCTOS,
  RUTA_SERVICIOS_GUARDERIA,
  RUTA_SERVICIOS_GUARDERIA_CREAR,
  RUTA_SERVICIOS_GUARDERIA_ID,
  RUTA_SERVICIOS_HOTEL,
  RUTA_SERVICIOS_HOTEL_CREAR,
  RUTA_SERVICIOS_HOTEL_ID,
  RUTA_SERVICIOS_ENTRENAMIENTO,
  RUTA_SERVICIOS_ENTRENAMIENTO_CREAR,
  RUTA_SERVICIOS_ENTRENAMIENTO_ID,
  RUTA_SERVICIOS_SPA,
  RUTA_SERVICIOS_SPA_CREAR,
  RUTA_SERVICIOS_SPA_ID,
  RUTA_SERVICIOS_TRANSPORTE,
  RUTA_SERVICIOS_TRANSPORTE_CREAR,
  RUTA_SERVICIOS_TRANSPORTE_ID,
  RUTA_PRODUCTOS,
  RUTA_PRODUCTOS_CREAR,
  RUTA_PRODUCTOS_ID,
  RUTA_RESERVAS,
  RUTA_RESERVAS_GUARDERIA,
  RUTA_RESERVAS_GUARDERIA_CREAR,
  RUTA_RESERVAS_GUARDERIA_LISTAR,
  RUTA_RESERVAS_GUARDERIA_CANCELAR,
  RUTA_RESERVAS_GUARDERIA_ID,
  RUTA_RESERVAS_HOTEL,
  RUTA_RESERVAS_HOTEL_CREAR,
  RUTA_RESERVAS_HOTEL_LISTAR,
  RUTA_RESERVAS_HOTEL_CANCELAR,
  RUTA_RESERVAS_HOTEL_ID,
  RUTA_RESERVAS_SPA,
  RUTA_RESERVAS_SPA_CREAR,
  RUTA_RESERVAS_SPA_LISTAR,
  RUTA_RESERVAS_SPA_ID,
  RUTA_VENTAS,
  RUTA_VENTAS_POR_PAGAR,
  RUTA_VENTAS_HISTORIAL,
  RUTA_VENTAS_ID,
  RUTA_ASISTENCIA,
  RUTA_ASISTENCIA_PROYECCIONES,
  RUTA_ASISTENCIA_CHECKIN,
  RUTA_ASISTENCIA_CHECKIN_ID,
  RUTA_ASISTENCIA_SPA_PROYECCIONES,
  RUTA_ASISTENCIA_SPA_CHECKIN,
  RUTA_TRANSPORTE,
  RUTA_TRANSPORTE_HOY,
  RUTA_TRANSPORTE_PLANEACION,
  RUTA_COMPRAS,
  RUTA_COMPRAS_COMPRAR,
  RUTA_CARRITO,
  RUTA_COMUNICACIONES,
  RUTA_COMUNICACIONES_REPORTE_DIARIO,
  RUTA_COMUNICACIONES_CORREOS_MASIVOS,
  RUTA_COMUNICACIONES_CORREOS_MASIVOS_PLANTILLA,
  RUTA_ANALISIS,
  RUTA_ANALISIS_FINANZAS,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA,
  RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO,
  RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO,
  RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES,
  RUTA_ANALISIS_OPERACIONES,
  RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS,
  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA,
  RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS,
  RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS,
  RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS,
  RUTA_ANALISIS_ENGLISH,
  RUTA_SEGURIDAD,
  RUTA_SEGURIDAD_ASIGNAR_ROLES,
  RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS,
} from "./rutas";

const PATRONES_RUTAS: Array<[string, string[]]> = [
  // Propietarios y Mascotas — literal routes first
  [RUTA_PROPIETARIOS_MASCOTAS, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_PROPIETARIOS_CREAR, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_PROPIETARIOS_EDITAR, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_PROPIETARIOS_MASCOTAS_CREAR, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_PROPIETARIOS_ID, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_PROPIETARIOS, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_MASCOTAS_EDITAR, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_MASCOTAS_ID, ["PROPIETARIOS_MASCOTAS"]],
  [RUTA_MASCOTAS, ["PROPIETARIOS_MASCOTAS"]],

  // Servicios
  [RUTA_SERVICIOS_PRODUCTOS, ["SERVICIOS", "PRODUCTOS"]],
  [RUTA_SERVICIOS_GUARDERIA_CREAR, ["SERVICIOS"]],
  [RUTA_SERVICIOS_GUARDERIA_ID, ["SERVICIOS"]],
  [RUTA_SERVICIOS_GUARDERIA, ["SERVICIOS"]],
  [RUTA_SERVICIOS_HOTEL_CREAR, ["SERVICIOS"]],
  [RUTA_SERVICIOS_HOTEL_ID, ["SERVICIOS"]],
  [RUTA_SERVICIOS_HOTEL, ["SERVICIOS"]],
  [RUTA_SERVICIOS_ENTRENAMIENTO_CREAR, ["SERVICIOS"]],
  [RUTA_SERVICIOS_ENTRENAMIENTO_ID, ["SERVICIOS"]],
  [RUTA_SERVICIOS_ENTRENAMIENTO, ["SERVICIOS"]],
  [RUTA_SERVICIOS_SPA_CREAR, ["SERVICIOS"]],
  [RUTA_SERVICIOS_SPA_ID, ["SERVICIOS"]],
  [RUTA_SERVICIOS_SPA, ["SERVICIOS"]],
  [RUTA_SERVICIOS_TRANSPORTE_CREAR, ["SERVICIOS"]],
  [RUTA_SERVICIOS_TRANSPORTE_ID, ["SERVICIOS"]],
  [RUTA_SERVICIOS_TRANSPORTE, ["SERVICIOS"]],
  [RUTA_SERVICIOS, ["SERVICIOS"]],

  // Productos
  [RUTA_PRODUCTOS_CREAR, ["PRODUCTOS"]],
  [RUTA_PRODUCTOS_ID, ["PRODUCTOS"]],
  [RUTA_PRODUCTOS, ["PRODUCTOS"]],

  // Reservas
  [RUTA_RESERVAS_GUARDERIA_CREAR, ["RESERVA_GUARDERIA"]],
  [RUTA_RESERVAS_GUARDERIA_LISTAR, ["LISTAR_AGENDAMIENTOS_GUARDERIA"]],
  [RUTA_RESERVAS_GUARDERIA_CANCELAR, ["RESERVA_GUARDERIA"]],
  [RUTA_RESERVAS_GUARDERIA_ID, ["LISTAR_AGENDAMIENTOS_GUARDERIA"]],
  [RUTA_RESERVAS_GUARDERIA, ["RESERVA_GUARDERIA"]],
  [RUTA_RESERVAS_HOTEL_CREAR, ["RESERVA_HOTEL"]],
  [RUTA_RESERVAS_HOTEL_LISTAR, ["LISTAR_AGENDAMIENTOS_HOTEL"]],
  [RUTA_RESERVAS_HOTEL_CANCELAR, ["RESERVA_HOTEL"]],
  [RUTA_RESERVAS_HOTEL_ID, ["LISTAR_AGENDAMIENTOS_HOTEL"]],
  [RUTA_RESERVAS_HOTEL, ["RESERVA_HOTEL"]],
  [RUTA_RESERVAS_SPA_CREAR, ["RESERVA_SPA"]],
  [RUTA_RESERVAS_SPA_LISTAR, ["LISTAR_AGENDAMIENTOS_SPA"]],
  [RUTA_RESERVAS_SPA_ID, ["LISTAR_AGENDAMIENTOS_SPA"]],
  [RUTA_RESERVAS_SPA, ["RESERVA_SPA"]],
  [RUTA_RESERVAS, ["RESERVA_GUARDERIA", "RESERVA_HOTEL", "RESERVA_SPA", "RESERVA_ENTRENAMIENTO", "LISTAR_AGENDAMIENTOS_GUARDERIA", "LISTAR_AGENDAMIENTOS_HOTEL", "LISTAR_AGENDAMIENTOS_SPA", "LISTAR_AGENDAMIENTOS_ENTRENAMIENTO"]],

  // Ventas (specific routes before parameterized)
  [RUTA_VENTAS_POR_PAGAR, ["LISTAR_VENTAS_POR_PAGAR"]],
  [RUTA_VENTAS_HISTORIAL, ["LISTAR_HISTORIAL_VENTAS"]],
  [RUTA_VENTAS_ID, ["VISUALIZAR_PAGAR_VENTA"]],
  [RUTA_VENTAS, ["LISTAR_VENTAS_POR_PAGAR", "LISTAR_HISTORIAL_VENTAS", "VISUALIZAR_PAGAR_VENTA"]],

  // Asistencia
  [RUTA_ASISTENCIA_SPA_PROYECCIONES, ["PROYECCIONES_SPA"]],
  [RUTA_ASISTENCIA_SPA_CHECKIN, ["CHECK_IN_SPA"]],
  [RUTA_ASISTENCIA_CHECKIN_ID, ["CHECK_IN"]],
  [RUTA_ASISTENCIA_CHECKIN, ["CHECK_IN"]],
  [RUTA_ASISTENCIA_PROYECCIONES, ["PROYECCIONES"]],
  [RUTA_ASISTENCIA, ["PROYECCIONES", "PROYECCIONES_SPA", "CHECK_IN", "CHECK_IN_SPA"]],

  // Transporte
  [RUTA_TRANSPORTE_HOY, ["HOJA_DIARIA_TRANSPORTE"]],
  [RUTA_TRANSPORTE_PLANEACION, ["PLANEAR_TRANSPORTES"]],
  [RUTA_TRANSPORTE, ["HOJA_DIARIA_TRANSPORTE", "PLANEAR_TRANSPORTES"]],

  // Compras
  [RUTA_COMPRAS_COMPRAR, ["COMPRAR_PRODUCTOS_MASCOTA"]],
  [RUTA_COMPRAS, ["COMPRAR_PRODUCTOS_MASCOTA", "LISTAR_COMPRAS"]],

  // Carrito
  [RUTA_CARRITO, ["RESERVA_GUARDERIA", "RESERVA_HOTEL", "RESERVA_SPA", "COMPRAR_PRODUCTOS_MASCOTA"]],

  // Comunicaciones
  [RUTA_COMUNICACIONES_REPORTE_DIARIO, ["REPORTE_DIARIO"]],
  [RUTA_COMUNICACIONES_CORREOS_MASIVOS_PLANTILLA, ["CORREOS_MASIVOS"]],
  [RUTA_COMUNICACIONES_CORREOS_MASIVOS, ["CORREOS_MASIVOS"]],
  [RUTA_COMUNICACIONES, ["REPORTE_DIARIO", "CORREOS_MASIVOS"]],

  // Analisis — Finanzas
  [RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MES, ["INGRESOS_POR_MES"]],
  [RUTA_ANALISIS_FINANZAS_INGRESOS_POR_DIA, ["INGRESOS_POR_DIA"]],
  [RUTA_ANALISIS_FINANZAS_INGRESOS_POR_PROPIETARIO, ["INGRESOS_POR_PROPIETARIO"]],
  [RUTA_ANALISIS_FINANZAS_INGRESOS_POR_MASCOTA, ["INGRESOS_POR_MASCOTA"]],
  [RUTA_ANALISIS_FINANZAS_INGRESOS_POR_SERVICIO, ["INGRESOS_POR_SERVICIO"]],
  [RUTA_ANALISIS_FINANZAS_DEUDAS_POR_PROPIETARIO, ["DEUDAS_POR_PROPIETARIO"]],
  [RUTA_ANALISIS_FINANZAS_DESCUENTOS_POR_MES, ["DESCUENTOS_POR_MES"]],
  [RUTA_ANALISIS_FINANZAS, ["INGRESOS_POR_MES", "INGRESOS_POR_DIA", "INGRESOS_POR_PROPIETARIO", "INGRESOS_POR_MASCOTA", "INGRESOS_POR_SERVICIO", "DEUDAS_POR_PROPIETARIO", "DESCUENTOS_POR_MES"]],

  // Analisis — Operaciones
  [RUTA_ANALISIS_OPERACIONES_ASISTENCIAS_POR_DIAS, ["ASISTENCIAS_POR_DIA"]],
  [RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS_POR_DIA, ["PLANES_ACTIVOS"]],
  [RUTA_ANALISIS_OPERACIONES_PLANES_ACTIVOS, ["PLANES_ACTIVOS"]],
  [RUTA_ANALISIS_OPERACIONES_MASCOTAS_DESERTORAS, ["MASCOTAS_DESERTORAS"]],
  [RUTA_ANALISIS_OPERACIONES_VACUNAS_VENCIDAS, ["VACUNAS_VENCIDAS"]],
  [RUTA_ANALISIS_OPERACIONES, ["ASISTENCIAS_POR_DIA", "PLANES_ACTIVOS", "MASCOTAS_DESERTORAS", "VACUNAS_VENCIDAS"]],

  [RUTA_ANALISIS, ["INGRESOS_POR_MES", "INGRESOS_POR_DIA", "INGRESOS_POR_PROPIETARIO", "INGRESOS_POR_MASCOTA", "INGRESOS_POR_SERVICIO", "DEUDAS_POR_PROPIETARIO", "DESCUENTOS_POR_MES", "ASISTENCIAS_POR_DIA", "PLANES_ACTIVOS", "MASCOTAS_DESERTORAS", "VACUNAS_VENCIDAS"]],
  [RUTA_ANALISIS_ENGLISH, ["INGRESOS_POR_MES", "INGRESOS_POR_DIA", "INGRESOS_POR_PROPIETARIO", "INGRESOS_POR_MASCOTA", "INGRESOS_POR_SERVICIO", "DEUDAS_POR_PROPIETARIO", "DESCUENTOS_POR_MES", "ASISTENCIAS_POR_DIA", "PLANES_ACTIVOS", "MASCOTAS_DESERTORAS", "VACUNAS_VENCIDAS"]],

  // Seguridad
  [RUTA_SEGURIDAD_ASIGNAR_ROLES, ["ASIGNAR_ROLES"]],
  [RUTA_SEGURIDAD_ADMINISTRAR_USUARIOS, ["ADMINISTRAR_USUARIOS"]],
  [RUTA_SEGURIDAD, ["ASIGNAR_ROLES", "ADMINISTRAR_USUARIOS"]],
];

const RUTAS_PUBLICAS = [RUTA_INICIO, RUTA_NO_AUTORIZADA];

export const tieneRol = (
  roles: RolUsuario[],
  codigo: string
): boolean => {
  return roles.some((r) => r.codigo === codigo);
};

export const tieneAlgunRol = (
  roles: RolUsuario[],
  codigos: string[]
): boolean => {
  return codigos.some((c) => tieneRol(roles, c));
};

export const tieneCategoria = (
  roles: RolUsuario[],
  categoria: string
): boolean => {
  return roles.some((r) => r.categoria === categoria);
};

export const puedeAccederRuta = (
  usuario: RespuestaUsuario | null | undefined,
  pathname: string
): boolean => {
  const roles = usuario?.roles || [];

  // Public routes accessible to any authenticated user
  if (RUTAS_PUBLICAS.includes(pathname)) return true;

  // Match against route patterns (ordered by specificity)
  for (const [patron, rolesRequeridos] of PATRONES_RUTAS) {
    const match = matchPath(patron, pathname);
    if (match) {
      return tieneAlgunRol(roles, rolesRequeridos);
    }
  }

  // Route not in any map: deny
  return false;
};

export const puedeVerCategoria = (
  usuario: RespuestaUsuario | null | undefined,
  categoria: string
): boolean => {
  const roles = usuario?.roles || [];

  // Empty categoria (no roles needed) — allow if any role
  if (!categoria) return roles.length > 0;
  return tieneCategoria(roles, categoria);
};
